module.exports = __webpack_public_path__ + "media/images/metronic/datatables/forward_enabled_hover-b0978ff876580be593c8236304a7edbc.png";